// Module
var code = `<template> <div class="partial-json"> <p if.bind="html"><b>Dated:</b> \${vetTask.thirdPartyPayloadDate | dateFormat}</p> <pre if.bind="html" innerhtml.bind="html"></pre> <p if.bind="!html">No data found!</p> </div> </template>`;
// Exports
module.exports = code;